import { call, put, takeEvery } from 'redux-saga/effects';

import { getEnvironmentConfig, getLogger, httpClientInterface } from '../../utils/core';
import { transformReportConfigurationToRequestData } from '../report-configurations/reportConfigurationsTransformers';

import { generatedReportsActions as actions } from './generatedReportsSlice';
import * as transformers from './generatedReportsTransformers';

const log = getLogger('app-components/flux/generated-reports/generatedReportsSagas.js');

export function* generateReport(action: any): Generator<any, any, any> {
  const {
    payload: { location, configuration },
    meta,
  } = action;
  log.debug('Generating report', configuration);

  let requestUrl = `${getEnvironmentConfig().services_url}/reports`;
  let requestBody: any;

  if (configuration.reportSubType === 'TAX_SCHEDULE') {
    // const businessId = '386124781100934400'; // Jeremy's
    const businessId = '381237512530772992'; // Ken's
    requestUrl += `/tax/${businessId}`;
  } else {
    requestUrl += `/generate`;
    requestBody = transformReportConfigurationToRequestData(configuration);
  }

  try {
    const response = requestBody
      ? yield call(httpClientInterface.send, 'POST', requestUrl, requestBody)
      : yield call(httpClientInterface.send, 'GET', requestUrl);
    log.debug('Generating report, response', response.data);

    const report = transformers.transformResponseToReport(response, configuration);
    yield put(actions.generateReportSuccess({ location, report }));
    meta?.resolve?.(report);
  } catch (error: any) {
    log.log('Received error', error, error.response);
    yield put(actions.generateReportFailure({ location, error }));
    meta?.reject?.(error);
  }
}

export function* generateReportActionWatcher() {
  yield takeEvery(actions.generateReport, generateReport);
}

export default [generateReportActionWatcher];
